import axios from 'axios';

// Zwraca token uwierzytelniajacy z najpewniejszego zrodla.
// Priorytet: globalny naglowek axios (trzymany w pamieci, ustawiany przy logowaniu)
// — odporny na blokade localStorage w przegladarkach z Tracking Prevention (np. Edge).
// Fallback: localStorage (gdyby axios.defaults nie bylo jeszcze ustawione).
export function getAuthToken(): string {
  try {
    const h = axios.defaults.headers.common['Authorization'];
    if (h && typeof h === 'string' && h.startsWith('Bearer ')) {
      return h.slice(7);
    }
  } catch {}
  try {
    return localStorage.getItem('token') || '';
  } catch {
    return '';
  }
}
